export enum STORAGE_KEY {
  REFERRAL_UUID = 'referral_uuid',
  REFERRAL_NUMBER = 'referral_number',
  PARTNERSHIP = 'partnership',
  PARTNERSHIP_ID = 'partnership_id',
  WELCOME_CALL_SOURCE = 'welcome_call_source',
  FF_USER_ID = 'ff_user_id',
}
